

import api from '../api';



const getTablesWithTimer = async (storeCode) => {
  const requestData = {
    "storeCode": storeCode
  }
  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/store/getTablesWithTimer", requestData);

    return response.data;

  } catch (error) {
    console.error(error)
    return error;
  }
}; // Removed requestData from dependencies


export default getTablesWithTimer;
